import React, { createContext, ReactNode, useContext, useState } from 'react';
import MediaModal from '../components/mediaModal/MediaModal';
import { AttachmentAssetType, IAttachment } from '../models/dms/attachment.model';

interface IComponentProps {
  children: ReactNode;
}

const MediaModalProvider: React.FC<IComponentProps> = function ({ children }) {
  /*
   ** State can be exposed through the private API
   */
  const [showModal, setShowModal] = useState<boolean>(false);
  const [attachment, setAttachment] = useState<IAttachment>({} as IAttachment);
  const [assetType, setAssetType] = useState<AttachmentAssetType>(AttachmentAssetType.WorkshopVehicle);
  const [assetKey, setAssetKey] = useState<string>('');
  const [handleDismiss, setHandleDismiss] = useState<() => void | undefined>();

  /*
   ** This method can be exposed through the private API but can only contain
   ** react specific code
   */
  const showMediaModal = (attachment: IAttachment, assetType: AttachmentAssetType, assetKey: string, handleDismiss?: () => void) => {
    setShowModal(true);
    setAttachment(attachment);
    setAssetType(assetType);
    setAssetKey(assetKey);
    setHandleDismiss(() => handleDismiss);
  };

  const hideMediaModal = () => {
    setShowModal(false);
  };

  return (
    <MediaModalContext.Provider
      value={{
        state: {},
        actions: {
          showMediaModal,
          hideMediaModal,
        },
      }}>
      {children}
      <MediaModal
        showModal={showModal}
        attachment={attachment}
        assetType={assetType}
        assetKey={assetKey}
        handleDismiss={() => {
          setShowModal(false);
          handleDismiss && handleDismiss();
        }}
      />
    </MediaModalContext.Provider>
  );
};

export const mediaModalProvider = {
  state: {} as {},
  actions: {} as {
    showMediaModal: (attachment: IAttachment, assetType: AttachmentAssetType, assetKey: string, handleDismiss?: () => void) => void;
    hideMediaModal: () => void;
  },
};

/*
 ** NOTE:
 ** To use this in react components, use the following code example:
 ** const { state: {showMediaModal}, actions: { privateMethod, showMediaModal }} = useMediaModal();
 **
 ** To use this in non-react components, use the following code example:
 ** mediaModalStatic.publicMethod();
 */

export const MediaModalContext = createContext<typeof mediaModalProvider>(mediaModalProvider);
export const useMediaModal = () => useContext(MediaModalContext);

// Expose methods for use in non-react components
export const mediaModalStatic = {};

export default MediaModalProvider;
